export const REPORT_TIME_ZONE = 'Asia/Jerusalem'

const READING_TIME = new Intl.DateTimeFormat('en-GB', {
  timeZone: REPORT_TIME_ZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
})

/** DD/MM/YYYY HH:MM on the Jerusalem clock, whatever offset the ISO text carries. */
export const formatReadingTime = (iso: string): string => {
  const part = Object.fromEntries(
    READING_TIME.formatToParts(new Date(iso)).map(({ type, value }) => [
      type,
      value,
    ])
  )
  return `${part.day}/${part.month}/${part.year} ${part.hour}:${part.minute}`
}
